import './styles.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import NavigationButton from './NavigationButton';
import React from 'react';
import NewsCard from 'components/NewsCards/NewsCard';

const NewsSlider = ({ data }) => {
    const modules = [Navigation, Pagination];
    const navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    };
    const breakpoints = {
        320: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
    };

    return (
        data.length && (
            <section className="container">
                <div className="news-slider-section">
                    <h2>!! You may be interested</h2>
                    <div className="news-slider">
                        <div className="news-slider__navigation">
                            <NavigationButton prev />
                            <NavigationButton />
                        </div>
                        <Swiper
                            pagination
                            modules={modules}
                            navigation={navigation}
                            breakpoints={breakpoints}
                            spaceBetween={8}
                        >
                            {data.map(item => (
                                <SwiperSlide key={item.title}>
                                    <NewsCard data={item} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>
        )
    );
};

export default NewsSlider;
